import { Mixins, Component, Prop } from "vue-property-decorator";
import { ConfirmSlidePanel } from "@/components/slide-panel";
import { VNode } from 'vue';

@Component
export default class PanelConfirm extends Mixins(ConfirmSlidePanel) {

  @Prop({required: false, default: "Attention"}) readonly title!: string;
  @Prop({required: false, default: "", type: [String, Object]}) readonly message!: string | VNode;

  get rootClasses() {
    return ["panel-confirm"];
  }

  renderHead() {
    return <span>{this.title}</span>
  }

  renderBody() {
    return <div>{this.message}</div>
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6f9a0109/panel-confirm.tsx" });